var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSelection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 8H5C3.897 8 3 7.103 3 6V4C3 2.897 3.897 2 5 2H19C20.103 2 21 2.897 21 4V6C21 7.103 20.103 8 19 8ZM5 4V6H18.997L19 4H5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 15H5C3.897 15 3 14.103 3 13V11C3 9.897 3.897 9 5 9H16C17.103 9 18 9.897 18 11V13C18 14.103 17.103 15 16 15ZM5 11V13H15.997L16 11H5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 22H5C3.897 22 3 21.103 3 20V18C3 16.897 3.897 16 5 16H13C14.103 16 15 16.897 15 18V20C15 21.103 14.103 22 13 22ZM5 18V20H12.997L13 18H5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSelection);
export default __webpack_public_path__ + "static/media/icon-selection.df6d3831575bb455214cc9dece7f8239.svg";
export { ForwardRef as ReactComponent };